import { QuestionCard } from '@/components/chat/bubbles/extractedQuestions/QuestionCard';
import { VStack } from '@/components/ui/vstack';
import type { ExtractedQuestion } from '@/types/extractedQuestions';

interface QuestionCardsListProps {
  extractedQuestions: ExtractedQuestion[];
  primaryQuestionIndex: number;
  position: 'left' | 'right';
  /** The recommended layout: hanging Q markers, rows 6px apart, spaced by the parent. */
  hanging?: boolean;
}

/**
 * The message's question cards, always shown under its text. They render
 * without an entrance animation because they are part of the message: a
 * fade-in would replay on every message each time a chat opens.
 */
export function QuestionCardsList({
  extractedQuestions,
  primaryQuestionIndex,
  position,
  hanging = false,
}: QuestionCardsListProps) {
  return (
    <VStack space={hanging ? undefined : 'xs'} className={hanging ? 'gap-1.5' : 'mt-2'}>
      {extractedQuestions.map((question, questionIndex) => (
        <QuestionCard
          key={questionIndex}
          question={question}
          questionIndex={questionIndex}
          isPrimary={questionIndex === primaryQuestionIndex}
          position={position}
          hanging={hanging}
        />
      ))}
    </VStack>
  );
}
